export default {"src":"/uk/_next/static/media/documentResourcesIcon.ce72b8d9.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};